import { PermissionType, sendGa4EventToGtm } from '@infrastructure/GoogleTagManager'

export const sendCookiePermissionUpdateGa4Event = (analyticsStorage: PermissionType, adStorage: PermissionType): void =>
    sendGa4EventToGtm({
        event_name: 'cookieUpdate',
        analytics_storage: analyticsStorage,
        ad_storage: adStorage,
        ad_user_data: adStorage,
        ad_personalization: adStorage,
        event: 'ga4Event',
    })

export const sendCookiePermissionDefaultGa4Event = (
    analyticsStorage: PermissionType,
    adStorage: PermissionType
): void =>
    sendGa4EventToGtm({
        event_name: 'cookieDefault',
        analytics_storage: analyticsStorage,
        ad_storage: adStorage,
        ad_user_data: adStorage,
        ad_personalization: adStorage,
        event: 'ga4Event',
    })
